const pino = require('pino');

/**
 * Severity overrides are for StackDriver.
 * https://github.com/pinojs/pino/blob/master/docs/help.md#mapping-pino-log-levels-to-google-cloud-logging-stackdriver-serverity-levels
 */
const PinoLevelToSeverityLookup = {
  debug: 'DEBUG',
  error: 'ERROR',
  fatal: 'CRITICAL',
  info: 'INFO',
  trace: 'DEBUG',
  warn: 'WARNING',
};

const defaultPinoConf = {
  base: null,
  formatters: {
    level(label, number) {
      return {
        level: number,
        severity:
          PinoLevelToSeverityLookup[label] || PinoLevelToSeverityLookup['info'],
      };
    },
  },
  messageKey: 'message',
  prettyPrint: process.env.NODE_ENV === 'development',
};

const logger = pino(defaultPinoConf);

module.exports = logger;
